import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp, faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { isWorkflowInput } from "@/components/Workflow/constants";
import { statePlaceholders } from "@/composables/useInvocationGraph";
import ToolLinkPopover from "../Tool/ToolLinkPopover.vue";
import WorkflowStepIcon from "./WorkflowStepIcon.vue";
import WorkflowStepTitle from "./WorkflowStepTitle.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationStepHeader',
    props: {
        workflowStep: null,
        graphStep: null,
        invocationStep: null,
        canExpand: { type: Boolean },
        expanded: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        library.add(faChevronDown, faChevronUp, faSignInAlt);
        return { __sfc: true, props, faChevronDown, faChevronUp, faSignInAlt, FontAwesomeIcon, isWorkflowInput, statePlaceholders, ToolLinkPopover, WorkflowStepIcon, WorkflowStepTitle };
    }
});
